import {useQuery} from 'react-query';
import getLikedStores from '.';

const useGetLikedStores = () => {
  const {data, isLoading} = useQuery(['liked-stores'], () => getLikedStores());

  return {data, isLoading};
};

export default useGetLikedStores;
